// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomTable_wrapper__aZjUj {
  margin-top: 1.5rem;
}

.CustomTable_customTable__U\\+qX7 {
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 10px;
  margin-top: 10px;
}

.CustomTable_tableRow__qf7KU {
  border: #e7e0f1 1px solid;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.CustomTable_rowData__1Pk94 {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
  row-gap: 22px;
  width: 100%;
}

.CustomTable_footerData__gVl13 {
  width: 100%;
}

.CustomTable_dataWrapper__pfDhp {
  display: flex;
  justify-content: start;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}

.CustomTable_data1__Ug5\\+H {
  min-width: 150px;
}

.CustomTable_data2__9nUCz {
  min-width: 200px;
}

.CustomTable_data3__4KfJ\\+ {
  min-width: 250px;
}

.CustomTable_data4__JOO4I {
  min-width: 300px;
}

.CustomTable_data5__arpRk {
  min-width: 350px;
}

.CustomTable_headerItem__o8ABU {
  display: flex;
  align-items: center;
  justify-content: start;
  flex-wrap: wrap;
  padding: 0px 0px 0px 0px;
  gap: 8px;
}

.CustomTable_sortButton__9zYS4 {
  background-color: transparent;
  border: none;
  color: #873caa;
}

.CustomTable_sortButton__9zYS4.p-button:enabled:hover {
  background-color: transparent;
  color: #873caa;
  border-color: transparent;
  box-shadow: none;
}

.CustomTable_sortButton__9zYS4.p-button:enabled:active {
  background-color: transparent;
  color: #873caa;
  border-color: transparent;
  box-shadow: none;
}

.CustomTable_sortButton__9zYS4.p-button:enabled:focus {
  background-color: transparent;
  color: #873caa;
  border-color: transparent;
  box-shadow: none;
}

.CustomTable_header__RWAD3 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.CustomTable_headerLabel__KTzMR {
  font-weight: 700;
  font-size: 12px;
  line-height: 16.34px;
  color: #495057;
}

.CustomTable_headerWrapper__uvgmS {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;
}

.CustomTable_dataHeader__o8-3L {
  font-weight: 600;
  font-size: 14px;
  line-height: 19.07px;
  color: #495057;
  display: block;
  width: 100%;
}

.CustomTable_dataItem__xVVC8 {
  font-size: 14px;
  font-weight: 400;
  line-height: 19.07px;
  color: #495057;
}

.CustomTable_dataActionItem__CSHtn {
  font-size: 14px;
  font-weight: 400;
  line-height: 19.07px;
  color: #495057;
  margin-left: auto;
}

.CustomTable_filterWrapper__RqlXI {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
  row-gap: 12px;
  margin-top: 10px;
}

.CustomTable_sortingWrapper__WeiJG {
  display: flex;
  justify-content: start;
  align-items: center;
  flex-wrap: wrap;
  min-width: 200px;
  padding-top: 8px;
}

.CustomTable_multiselectFilter__KukJq.p-multiselect .p-multiselect-label.p-placeholder {
  font-size: 0.89rem !important;
  color: #999999;
}

.CustomTable_sortLabel__es8z6 {
  font-weight: 400;
  line-height: 16.34px;
  font-size: 12px;
  color: #495057;
}

.CustomTable_sortItem__aAB4U {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.CustomTable_filterTemplateItem__JklhZ {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.CustomTable_filterTemplateLabel__cyPdW {
  font-weight: 400;
  line-height: 16.34px;
  color: #495057 !important;
}

.CustomTable_paginator__2cqlF {
  margin-top: 10px;
}

.CustomTable_filterMobileItem__tvtZf {
  background-color: rgba(135, 60, 170, 0.1);
  border-radius: 16px;
  padding: 3px 10.5px;
  font-size: 14px;
  color: #4b5563;
  font-weight: 400;
  display: inline-flex;
  /* Ensures width adapts to content */
  align-items: center;
  justify-content: center;
  max-width: max-content;
  /* Avoid full width */
  white-space: nowrap;
  /* Prevents text from wrapping */
  margin-right: 10px;
  margin-bottom: 10px;
}

.CustomTable_filterMobileItemIcon__LokHJ {
  background-color: transparent;
  color: #4b5563;
  border: none !important;
  padding: 0px;
}

.CustomTable_filterMobileItemIcon__LokHJ:focus {
  box-shadow: none !important;
}

.CustomTable_sortingItem__qa9ow {
  width: 100%;
}

.CustomTable_tableRowBorder__b5Cq9 {
  border-radius: 12px;
  border-style: solid;
  border-width: 1px;
  border-color: var(--branded-purple-border);
}

.CustomTable_filterItemBorder__qfO5l {
  border-style: solid;
  border-width: 1px;
  border-color: var(--branded-purple-border);
}

/* mobile */
@media (max-width: 768px) {
  .CustomTable_dataActionItem__CSHtn {
    margin-left: 0px;
  }

  .CustomTable_filterItem__ty3d5 {
    display: none;
  }

  .CustomTable_sortingItem__qa9ow {
    width: 100%;
  }

  .CustomTable_sortingWrapper__WeiJG {
    width: 100%;
    padding-top: 0px;
  }

  .CustomTable_headerWrapper__uvgmS {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
  }

  .CustomTable_filterWrapperMobile__hpJoj {
    display: flex;
    align-items: center;
    justify-content: start;
    flex-wrap: wrap;
    gap: 10px;
    width: 100%;
  }

  .CustomTable_filterMobile__uSk1s {
    background-color: transparent;
    color: #383838;
    font-weight: 600;
    font-size: 16px;
    line-height: 21.79px;
  }

  .CustomTable_filterMobileModalTitle__Chw-B {
    font-size: 24px;
    font-weight: 700;
    line-height: 32.68px;
    color: #383838;
  }

  .CustomTable_filterMobileModalHeader__YmgpW {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1.5rem;
    margin-top: 1rem;
  }

  .CustomTable_filterMobileModalFooter__13n8e {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    margin-top: 10px;
  }

  .CustomTable_headerItem__o8ABU {
    display: flex;
    align-items: center;
    justify-content: start;
    flex-wrap: wrap;
    padding: 10px 0px 10px 0px;
  }
}

/* tablet */
@media (min-width: 768px) and (max-width: 1024px) {
  .CustomTable_dataActionItem__CSHtn {
    margin-left: 0px;
  }

  .CustomTable_mobileFilters__lYgPF {
    display: none;
  }

  .CustomTable_filterWrapper__RqlXI {
    display: flex;
    justify-content: start;
    align-items: center;
    flex-wrap: wrap;
    gap: 20px;
    row-gap: 0px;
  }

  .CustomTable_filterWrapperMobile__hpJoj {
    display: none;
  }
}

/* full */
@media (min-width: 1024px) {
  .CustomTable_filterWrapperMobile__hpJoj {
    display: none;
  }

  .CustomTable_showFiltersMobile__z\\+Muq {
    display: none;
  }
}

.CustomTable_rounded_btn__gDz1W {
  width: 40px !important;
  height: 40px;
  border-radius: 50%;
  color: #873caa;
  background: rgba(222, 190, 237, 0.5);
  border: none !important;
}

.CustomTable_mobileFooterButton__fLYnq {
  font-size: 16px;
  line-height: 21.79px;
  font-weight: 600;
  border-radius: 28px;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 24px;
  padding-right: 24px;
  min-width: fit-content;
}

.CustomTable_resetButton__lrF0C {
  background-color: transparent;
  border: none !important;
  color: #873caa;
  width: 100%;
  padding-left: 0px;
  text-align: left;
}

.CustomTable_cancelButton__FV2aL {
  background-color: transparent;
  color: #873caa;
  border-color: #873caa;
}

.CustomTable_calendar__ceh1v button {
  background-color: white !important;
  border-color: var(--branded-light-purple) !important;
  border-left: none !important;
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
  height: 40px;
  color: #873caa;
}

.CustomTable_calendar__ceh1v button:hover {
  border-color: #ced4da !important;
  color: white !important;
  background-color: #873caa !important;
}

.CustomTable_calendar__ceh1v input {
  border-right: none;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}

.CustomTable_searchFilter__dlv0W .p-inputtext {
  padding-left: 2.5rem !important;
  color: #383838;
  font-style: italic;
  font-weight: 400;
  line-height: 19.07px;
  font-size: 14px;
}

.CustomTable_searchFilter__dlv0W span {
  color: #873caa;
}

.CustomTable_tag__1jeD- {
  border-radius: 4px;
  padding: 4px 10px 4px 10px;
  font-weight: 600;
  font-size: 14px;
  line-height: 19.07px;
}

.CustomTable_active__u7UA0 {
  color: #22c55e !important;
  background-color: #d4f1e0;
}

.CustomTable_complete__6lyCP {
  color: #3b82f6 !important;
  background-color: rgba(59, 130, 246, 0.2);
}

.CustomTable_pending__QBisI {
  color: #888888 !important;
  background-color: #d9d9d9;
}

.CustomTable_incomplete__h3uJE {
  color: #c1850e;
  background-color: #fce0aa;
}
`, "",{"version":3,"sources":["webpack://./src/styles/customTable/CustomTable.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,2BAA2B;EAC3B,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,wBAAwB;EACxB,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,oCAAoC;EACpC,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA,WAAW;AACX;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,SAAS;IACT,WAAW;EACb;;EAEA;IACE,6BAA6B;IAC7B,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,0BAA0B;EAC5B;AACF;;AAEA,WAAW;AACX;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,SAAS;AACT;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,oDAAoD;EACpD,4BAA4B;EAC5B,sCAAsC;EACtC,yCAAyC;EACzC,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B","sourcesContent":[".wrapper {\n  margin-top: 1.5rem;\n}\n\n.customTable {\n  display: grid;\n  grid-template-columns: 1fr;\n  row-gap: 10px;\n  margin-top: 10px;\n}\n\n.tableRow {\n  border: #e7e0f1 1px solid;\n  border-radius: 12px;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.rowData {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: flex-start;\n  row-gap: 22px;\n  width: 100%;\n}\n\n.footerData {\n  width: 100%;\n}\n\n.dataWrapper {\n  display: flex;\n  justify-content: start;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.data1 {\n  min-width: 150px;\n}\n\n.data2 {\n  min-width: 200px;\n}\n\n.data3 {\n  min-width: 250px;\n}\n\n.data4 {\n  min-width: 300px;\n}\n\n.data5 {\n  min-width: 350px;\n}\n\n.headerItem {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  flex-wrap: wrap;\n  padding: 0px 0px 0px 0px;\n  gap: 8px;\n}\n\n.sortButton {\n  background-color: transparent;\n  border: none;\n  color: #873caa;\n}\n\n.sortButton:global(.p-button:enabled:hover) {\n  background-color: transparent;\n  color: #873caa;\n  border-color: transparent;\n  box-shadow: none;\n}\n\n.sortButton:global(.p-button:enabled:active) {\n  background-color: transparent;\n  color: #873caa;\n  border-color: transparent;\n  box-shadow: none;\n}\n\n.sortButton:global(.p-button:enabled:focus) {\n  background-color: transparent;\n  color: #873caa;\n  border-color: transparent;\n  box-shadow: none;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.headerLabel {\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 16.34px;\n  color: #495057;\n}\n\n.headerWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.dataHeader {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 19.07px;\n  color: #495057;\n  display: block;\n  width: 100%;\n}\n\n.dataItem {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 19.07px;\n  color: #495057;\n}\n\n.dataActionItem {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 19.07px;\n  color: #495057;\n  margin-left: auto;\n}\n\n.filterWrapper {\n  display: flex;\n  justify-content: start;\n  align-items: center;\n  gap: 20px;\n  flex-wrap: wrap;\n  row-gap: 12px;\n  margin-top: 10px;\n}\n\n.sortingWrapper {\n  display: flex;\n  justify-content: start;\n  align-items: center;\n  flex-wrap: wrap;\n  min-width: 200px;\n  padding-top: 8px;\n}\n\n.multiselectFilter:global(.p-multiselect .p-multiselect-label.p-placeholder) {\n  font-size: 0.89rem !important;\n  color: #999999;\n}\n\n.sortLabel {\n  font-weight: 400;\n  line-height: 16.34px;\n  font-size: 12px;\n  color: #495057;\n}\n\n.sortItem {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n}\n\n.filterTemplateItem {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.filterTemplateLabel {\n  font-weight: 400;\n  line-height: 16.34px;\n  color: #495057 !important;\n}\n\n.paginator {\n  margin-top: 10px;\n}\n\n.filterMobileItem {\n  background-color: rgba(135, 60, 170, 0.1);\n  border-radius: 16px;\n  padding: 3px 10.5px;\n  font-size: 14px;\n  color: #4b5563;\n  font-weight: 400;\n  display: inline-flex;\n  /* Ensures width adapts to content */\n  align-items: center;\n  justify-content: center;\n  max-width: max-content;\n  /* Avoid full width */\n  white-space: nowrap;\n  /* Prevents text from wrapping */\n  margin-right: 10px;\n  margin-bottom: 10px;\n}\n\n.filterMobileItemIcon {\n  background-color: transparent;\n  color: #4b5563;\n  border: none !important;\n  padding: 0px;\n}\n\n.filterMobileItemIcon:focus {\n  box-shadow: none !important;\n}\n\n.sortingItem {\n  width: 100%;\n}\n\n.tableRowBorder {\n  border-radius: 12px;\n  border-style: solid;\n  border-width: 1px;\n  border-color: var(--branded-purple-border);\n}\n\n.filterItemBorder {\n  border-style: solid;\n  border-width: 1px;\n  border-color: var(--branded-purple-border);\n}\n\n/* mobile */\n@media (max-width: 768px) {\n  .dataActionItem {\n    margin-left: 0px;\n  }\n\n  .filterItem {\n    display: none;\n  }\n\n  .sortingItem {\n    width: 100%;\n  }\n\n  .sortingWrapper {\n    width: 100%;\n    padding-top: 0px;\n  }\n\n  .headerWrapper {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-direction: column;\n  }\n\n  .filterWrapperMobile {\n    display: flex;\n    align-items: center;\n    justify-content: start;\n    flex-wrap: wrap;\n    gap: 10px;\n    width: 100%;\n  }\n\n  .filterMobile {\n    background-color: transparent;\n    color: #383838;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 21.79px;\n  }\n\n  .filterMobileModalTitle {\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 32.68px;\n    color: #383838;\n  }\n\n  .filterMobileModalHeader {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 1.5rem;\n    margin-top: 1rem;\n  }\n\n  .filterMobileModalFooter {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 10px;\n    margin-top: 10px;\n  }\n\n  .headerItem {\n    display: flex;\n    align-items: center;\n    justify-content: start;\n    flex-wrap: wrap;\n    padding: 10px 0px 10px 0px;\n  }\n}\n\n/* tablet */\n@media (min-width: 768px) and (max-width: 1024px) {\n  .dataActionItem {\n    margin-left: 0px;\n  }\n\n  .mobileFilters {\n    display: none;\n  }\n\n  .filterWrapper {\n    display: flex;\n    justify-content: start;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 20px;\n    row-gap: 0px;\n  }\n\n  .filterWrapperMobile {\n    display: none;\n  }\n}\n\n/* full */\n@media (min-width: 1024px) {\n  .filterWrapperMobile {\n    display: none;\n  }\n\n  .showFiltersMobile {\n    display: none;\n  }\n}\n\n.rounded_btn {\n  width: 40px !important;\n  height: 40px;\n  border-radius: 50%;\n  color: #873caa;\n  background: rgba(222, 190, 237, 0.5);\n  border: none !important;\n}\n\n.mobileFooterButton {\n  font-size: 16px;\n  line-height: 21.79px;\n  font-weight: 600;\n  border-radius: 28px;\n  padding-top: 12px;\n  padding-bottom: 12px;\n  padding-left: 24px;\n  padding-right: 24px;\n  min-width: fit-content;\n}\n\n.resetButton {\n  background-color: transparent;\n  border: none !important;\n  color: #873caa;\n  width: 100%;\n  padding-left: 0px;\n  text-align: left;\n}\n\n.cancelButton {\n  background-color: transparent;\n  color: #873caa;\n  border-color: #873caa;\n}\n\n.calendar button {\n  background-color: white !important;\n  border-color: var(--branded-light-purple) !important;\n  border-left: none !important;\n  border-top-left-radius: 0px !important;\n  border-bottom-left-radius: 0px !important;\n  height: 40px;\n  color: #873caa;\n}\n\n.calendar button:hover {\n  border-color: #ced4da !important;\n  color: white !important;\n  background-color: #873caa !important;\n}\n\n.calendar input {\n  border-right: none;\n  border-top-right-radius: 0px !important;\n  border-bottom-right-radius: 0px !important;\n}\n\n.searchFilter :global(.p-inputtext) {\n  padding-left: 2.5rem !important;\n  color: #383838;\n  font-style: italic;\n  font-weight: 400;\n  line-height: 19.07px;\n  font-size: 14px;\n}\n\n.searchFilter span {\n  color: #873caa;\n}\n\n.tag {\n  border-radius: 4px;\n  padding: 4px 10px 4px 10px;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 19.07px;\n}\n\n.active {\n  color: #22c55e !important;\n  background-color: #d4f1e0;\n}\n\n.complete {\n  color: #3b82f6 !important;\n  background-color: rgba(59, 130, 246, 0.2);\n}\n\n.pending {\n  color: #888888 !important;\n  background-color: #d9d9d9;\n}\n\n.incomplete {\n  color: #c1850e;\n  background-color: #fce0aa;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `CustomTable_wrapper__aZjUj`,
	"customTable": `CustomTable_customTable__U+qX7`,
	"tableRow": `CustomTable_tableRow__qf7KU`,
	"rowData": `CustomTable_rowData__1Pk94`,
	"footerData": `CustomTable_footerData__gVl13`,
	"dataWrapper": `CustomTable_dataWrapper__pfDhp`,
	"data1": `CustomTable_data1__Ug5+H`,
	"data2": `CustomTable_data2__9nUCz`,
	"data3": `CustomTable_data3__4KfJ+`,
	"data4": `CustomTable_data4__JOO4I`,
	"data5": `CustomTable_data5__arpRk`,
	"headerItem": `CustomTable_headerItem__o8ABU`,
	"sortButton": `CustomTable_sortButton__9zYS4`,
	"header": `CustomTable_header__RWAD3`,
	"headerLabel": `CustomTable_headerLabel__KTzMR`,
	"headerWrapper": `CustomTable_headerWrapper__uvgmS`,
	"dataHeader": `CustomTable_dataHeader__o8-3L`,
	"dataItem": `CustomTable_dataItem__xVVC8`,
	"dataActionItem": `CustomTable_dataActionItem__CSHtn`,
	"filterWrapper": `CustomTable_filterWrapper__RqlXI`,
	"sortingWrapper": `CustomTable_sortingWrapper__WeiJG`,
	"multiselectFilter": `CustomTable_multiselectFilter__KukJq`,
	"sortLabel": `CustomTable_sortLabel__es8z6`,
	"sortItem": `CustomTable_sortItem__aAB4U`,
	"filterTemplateItem": `CustomTable_filterTemplateItem__JklhZ`,
	"filterTemplateLabel": `CustomTable_filterTemplateLabel__cyPdW`,
	"paginator": `CustomTable_paginator__2cqlF`,
	"filterMobileItem": `CustomTable_filterMobileItem__tvtZf`,
	"filterMobileItemIcon": `CustomTable_filterMobileItemIcon__LokHJ`,
	"sortingItem": `CustomTable_sortingItem__qa9ow`,
	"tableRowBorder": `CustomTable_tableRowBorder__b5Cq9`,
	"filterItemBorder": `CustomTable_filterItemBorder__qfO5l`,
	"filterItem": `CustomTable_filterItem__ty3d5`,
	"filterWrapperMobile": `CustomTable_filterWrapperMobile__hpJoj`,
	"filterMobile": `CustomTable_filterMobile__uSk1s`,
	"filterMobileModalTitle": `CustomTable_filterMobileModalTitle__Chw-B`,
	"filterMobileModalHeader": `CustomTable_filterMobileModalHeader__YmgpW`,
	"filterMobileModalFooter": `CustomTable_filterMobileModalFooter__13n8e`,
	"mobileFilters": `CustomTable_mobileFilters__lYgPF`,
	"showFiltersMobile": `CustomTable_showFiltersMobile__z+Muq`,
	"rounded_btn": `CustomTable_rounded_btn__gDz1W`,
	"mobileFooterButton": `CustomTable_mobileFooterButton__fLYnq`,
	"resetButton": `CustomTable_resetButton__lrF0C`,
	"cancelButton": `CustomTable_cancelButton__FV2aL`,
	"calendar": `CustomTable_calendar__ceh1v`,
	"searchFilter": `CustomTable_searchFilter__dlv0W`,
	"tag": `CustomTable_tag__1jeD-`,
	"active": `CustomTable_active__u7UA0`,
	"complete": `CustomTable_complete__6lyCP`,
	"pending": `CustomTable_pending__QBisI`,
	"incomplete": `CustomTable_incomplete__h3uJE`
};
export default ___CSS_LOADER_EXPORT___;
